// Product Image Gallery Swiper Module
// Extracted from theme.js for modular loading
// Supports 3 layout types: gallery, horizontal-tabs, default

(function () {
    // Check if Swiper is available
    function checkSwiperAvailable() {
        if (typeof Swiper === 'undefined') {
            return false;
        }
        return true;
    }

    // Initialize product image gallery with Swiper
    function initProductImageGallery(scope) {
        // Check if Swiper is available
        if (!checkSwiperAvailable()) {
            return null;
        }

        const productView = scope || document.querySelector('.productView');
        if (!productView) return null;

        // Verify it's a valid DOM element
        if (!(productView instanceof Element)) return null;

        const sliderNav = productView.querySelector('.productView-nav');
        const sliderFor = productView.querySelector('.productView-for:not(.mobile)');
        const sliderForMobile = productView.querySelector('.productView-for.mobile');

        if (!sliderNav) return null;

        // Verify sliderNav is valid
        if (!(sliderNav instanceof Element)) return null;

        // Check if Slick is already initialized (avoid conflict)
        if (sliderNav.classList.contains('slick-initialized')) {
            return null;
        }

        // Check if already initialized
        if (sliderNav.classList.contains('swiper-initialized')) return null;

        // Ensure Swiper structure exists
        let navWrapper = sliderNav.querySelector('.swiper-wrapper');
        if (!navWrapper) {
            navWrapper = document.createElement('div');
            navWrapper.className = 'swiper-wrapper';
            Array.from(sliderNav.children).forEach(child => {
                child.classList.add('swiper-slide');
                navWrapper.appendChild(child);
            });
            if (navWrapper.children.length > 0) sliderNav.appendChild(navWrapper);
            else return;
        }

        if (sliderFor) {
            let forWrapper = sliderFor.querySelector('.swiper-wrapper');
            if (!forWrapper) {
                forWrapper = document.createElement('div');
                forWrapper.className = 'swiper-wrapper';
                Array.from(sliderFor.children).forEach(child => {
                    child.classList.add('swiper-slide');
                    forWrapper.appendChild(child);
                });
                if (forWrapper.children.length > 0) sliderFor.appendChild(forWrapper);
            }
        }

        // Get configuration from data attributes
        const navArrowsDesk = sliderNav.dataset.arrowsDesk === 'true';
        const navArrowsMobi = sliderNav.dataset.arrowsMobi === 'true';
        const navCounterMobi = sliderNav.dataset.counterMobi === 'true';
        const navMediaCount = parseInt(sliderNav.dataset.mediaCount) || 1;
        const thumbnailToShow = parseInt(sliderFor?.dataset.maxThumbnailToShow) || 4;

        let navSwiper, forSwiper;

        // Counter creation function
        function createCounter(total) {
            return `
                <div class="swiper-counter">
                    <span class="swiper-counter--current">1</span>
                    <span aria-hidden="true">/</span>
                    <span class="swiper-counter--total">${total}</span>
                </div>
            `;
        }

        // Update counter on slide change
        function updateCounter(swiper) {
            const counter = swiper.el.querySelector('.swiper-counter--current');
            if (counter) {
                counter.textContent = swiper.realIndex + 1;
            }
        }

        // Manually sync the "active" class on thumbnail slides.
        // Swiper's thumbs helper should handle this, but in our setup the first
        // thumb was staying active. We enforce the correct state on slide change
        // and on thumb click to match the currently displayed main slide.
        function syncThumbActive(thumbSwiper, activeIndex) {
            if (!thumbSwiper || !thumbSwiper.slides) return;
            thumbSwiper.slides.forEach((slide, idx) => {
                slide.classList.toggle('swiper-slide-thumb-active', idx === activeIndex);
            });
        }

        // LAYOUT 1: Gallery (2x2 grid on desktop, slider on mobile)
        if (sliderNav.classList.contains('productView-nav-gallery')) {
            let show = 2;
            let rows = 2;
            const length = navMediaCount;
            const oneItems = sliderNav.dataset['1-itemMobi'] === 'true';

            if (length === 1) {
                show = 1;
                rows = 1;
            } else if (length === 2) {
                show = 2;
                rows = 1;
            }

            if (oneItems && window.innerWidth < 551) {
                show = 1;
                rows = 1;
            }

            const navTotal = Math.ceil(navMediaCount / (show * rows));

            navSwiper = new Swiper(sliderNav, {
                slidesPerView: show,
                slidesPerGroup: show,
                grid: {
                    rows: rows,
                    fill: 'row'
                },
                spaceBetween: 10,
                loop: false,
                watchOverflow: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    enabled: navArrowsDesk
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    768: {
                        navigation: {
                            enabled: navArrowsDesk
                        }
                    },
                    0: {
                        navigation: {
                            enabled: navArrowsMobi
                        }
                    }
                },
                on: {
                    init: function (swiper) {
                        if (window.innerWidth < 768 && navCounterMobi) {
                            swiper.el.insertAdjacentHTML('beforeend', createCounter(navTotal));
                        }
                        // Update lazy load
                        if (window.lazyLoadInstance) {
                            window.lazyLoadInstance.update();
                        }
                    },
                    slideChange: function (swiper) {
                        updateCounter(swiper);
                    },
                    resize: function (swiper) {
                        if (window.innerWidth < 768 && navCounterMobi) {
                            const existing = swiper.el.querySelector('.swiper-counter');
                            if (!existing) {
                                swiper.el.insertAdjacentHTML('beforeend', createCounter(navTotal));
                            }
                        }
                    }
                }
            });
        }
        // LAYOUT 2: Horizontal Tabs
        else if (sliderNav.classList.contains('productView-horizontal-tabs')) {
            // Get or create navigation buttons
            let nextBtn = sliderNav.querySelector('.swiper-button-next');
            let prevBtn = sliderNav.querySelector('.swiper-button-prev');
            let paginationEl = sliderNav.querySelector('.swiper-pagination');

            // If not found in sliderNav, try parent container
            if (!nextBtn || !prevBtn) {
                const parentContainer = sliderNav.closest('.productView-image-wrapper') || sliderNav.parentElement;
                if (parentContainer) {
                    nextBtn = parentContainer.querySelector('.swiper-button-next') || nextBtn;
                    prevBtn = parentContainer.querySelector('.swiper-button-prev') || prevBtn;
                }
            }
            if (!paginationEl) {
                const parentContainer = sliderNav.closest('.productView-image-wrapper') || sliderNav.parentElement;
                if (parentContainer) {
                    paginationEl = parentContainer.querySelector('.swiper-pagination') || paginationEl;
                }
            }

            // Create buttons if they don't exist
            if (!nextBtn) {
                nextBtn = document.createElement('div');
                nextBtn.className = 'swiper-button-next';
                sliderNav.appendChild(nextBtn);
            }
            if (!prevBtn) {
                prevBtn = document.createElement('div');
                prevBtn.className = 'swiper-button-prev';
                sliderNav.appendChild(prevBtn);
            }

            // Create pagination if it doesn't exist
            if (!paginationEl) {
                paginationEl = document.createElement('div');
                paginationEl.className = 'swiper-pagination';
                sliderNav.appendChild(paginationEl);
            }

            // Add SVG icons to buttons if available
            if (window.arrows) {
                if (nextBtn && window.arrows.icon_next && !nextBtn.querySelector('svg')) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = window.arrows.icon_next;
                    const iconSvg = tempDiv.querySelector('svg');
                    if (iconSvg) {
                        nextBtn.innerHTML = '';
                        nextBtn.appendChild(iconSvg.cloneNode(true));
                    }
                }
                if (prevBtn && window.arrows.icon_prev && !prevBtn.querySelector('svg')) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = window.arrows.icon_prev;
                    const iconSvg = tempDiv.querySelector('svg');
                    if (iconSvg) {
                        prevBtn.innerHTML = '';
                        prevBtn.appendChild(iconSvg.cloneNode(true));
                    }
                }
            }

            // Determine initial navigation state based on screen size
            const isMobile = window.innerWidth < 768;
            const showArrows = isMobile ? navArrowsMobi : navArrowsDesk;

            navSwiper = new Swiper(sliderNav, {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 10,
                loop: false,
                watchOverflow: true,
                navigation: showArrows && nextBtn && prevBtn ? {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                } : false,
                pagination: paginationEl ? {
                    el: paginationEl,
                    clickable: true,
                    type: 'bullets'
                } : false,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        navigation: navArrowsDesk && nextBtn && prevBtn ? {
                            nextEl: nextBtn,
                            prevEl: prevBtn
                        } : false,
                        pagination: paginationEl ? {
                            el: paginationEl,
                            clickable: true,
                            type: 'bullets'
                        } : false
                    },
                    0: {
                        slidesPerView: () => {
                            return sliderNav.closest('.featured-product') ? 1 : 2;
                        },
                        navigation: navArrowsMobi && nextBtn && prevBtn ? {
                            nextEl: nextBtn,
                            prevEl: prevBtn
                        } : false,
                        pagination: paginationEl ? {
                            el: paginationEl,
                            clickable: true,
                            type: 'bullets'
                        } : false
                    }
                },
                on: {
                    init: function (swiper) {
                        // Mark as initialized
                        sliderNav.classList.add('swiper-initialized');
                        sliderNav.swiperInstance = this;

                        if (window.lazyLoadInstance) {
                            window.lazyLoadInstance.update();
                        }
                    },
                    slideChange: function (swiper) {
                        updateCounter(swiper);
                    },
                    resize: function (swiper) {
                        // Update navigation state on resize
                        const isMobileNow = window.innerWidth < 768;
                        const shouldShowArrows = isMobileNow ? navArrowsMobi : navArrowsDesk;

                        if (shouldShowArrows && nextBtn && prevBtn) {
                            if (!swiper.params.navigation) {
                                swiper.params.navigation = {};
                            }
                            swiper.params.navigation.nextEl = nextBtn;
                            swiper.params.navigation.prevEl = prevBtn;
                            swiper.navigation.init();
                            swiper.navigation.update();
                        } else if (swiper.params.navigation) {
                            swiper.navigation.destroy();
                            swiper.params.navigation = false;
                        }
                    }
                }
            });
        }
        // LAYOUT 3: Default (fade slider)
        else {
            const isStyle2or3 = sliderNav.classList.contains('style-2') ||
                sliderNav.classList.contains('style-3');

            if (!isStyle2or3 || window.innerWidth < 768) {
                // Initialize thumbnail slider FIRST if exists (required for thumbs option)
                let thumbSwiper = null;
                const isLayoutFull = productView.classList.contains('layout-4');

                if (sliderFor && !sliderFor.classList.contains('swiper-initialized') && !isLayoutFull) {
                    // Get navigation buttons from thumbnail wrapper (already in HTML)
                    const thumbnailWrapper = sliderFor.parentElement;
                    const thumbNextBtn = thumbnailWrapper?.querySelector('.swiper-button-next');
                    const thumbPrevBtn = thumbnailWrapper?.querySelector('.swiper-button-prev');

                    // Initialize thumbnail slider as vertical
                    thumbSwiper = new Swiper(sliderFor, {
                        direction: 'vertical',
                        slidesPerView: 'auto',
                        spaceBetween: 10,
                        loop: false,
                        watchOverflow: true,
                        freeMode: true,
                        watchSlidesProgress: true,
                        navigation: thumbNextBtn && thumbPrevBtn ? {
                            nextEl: thumbNextBtn,
                            prevEl: thumbPrevBtn
                        } : false,
                        on: {
                            init: function (swiper) {
                                if (window.lazyLoadInstance) {
                                    window.lazyLoadInstance.update();
                                }
                            }
                        }
                    });
                }

                // Buscar paginação mobile se existir
                const mobilePagination = productView.querySelector('.productView-pagination-mobile');
                const paginationEl = mobilePagination || sliderNav.querySelector('.swiper-pagination');

                // Determine initial effect based on screen size
                const isMobile = window.innerWidth < 768;
                const initialEffect = isMobile ? 'slide' : 'fade';

                navSwiper = new Swiper(sliderNav, {
                    effect: initialEffect,
                    fadeEffect: !isMobile ? {
                        crossFade: true
                    } : undefined,
                    slidesPerView: isMobile ? 1.1 : 1,
                    spaceBetween: isMobile ? 10 : 0,
                    loop: false,
                    watchOverflow: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        enabled: isMobile ? navArrowsMobi : navArrowsDesk
                    },
                    pagination: paginationEl ? {
                        el: paginationEl,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        }
                    } : false,
                    thumbs: thumbSwiper ? {
                        swiper: thumbSwiper
                    } : false,
                    breakpoints: {
                        768: {
                            effect: 'fade',
                            fadeEffect: {
                                crossFade: true
                            },
                            slidesPerView: 1,
                            spaceBetween: 0,
                            navigation: {
                                enabled: navArrowsDesk
                            }
                        },
                        0: {
                            effect: 'slide',
                            slidesPerView: 1.1,
                            spaceBetween: 10,
                            navigation: {
                                enabled: navArrowsMobi
                            }
                        }
                    },
                    on: {
                        init: function (swiper) {
                            if (window.innerWidth < 768 && navCounterMobi) {
                                const counter = createCounter(navMediaCount);
                                const appendTarget = document.querySelector('[data-image-gallery-main]') || swiper.el;
                                appendTarget.insertAdjacentHTML('beforeend', counter);
                            }

                            // Force position recalculation after images load
                            requestAnimationFrame(() => {
                                const images = swiper.el.querySelectorAll('img');
                                let loadedCount = 0;
                                const totalImages = images.length;

                                images.forEach(img => {
                                    if (img.complete) {
                                        loadedCount++;
                                    } else {
                                        img.addEventListener('load', () => {
                                            loadedCount++;
                                            if (loadedCount === totalImages) {
                                                swiper.update();
                                            }
                                        });
                                    }
                                });

                                if (loadedCount === totalImages) {
                                    swiper.update();
                                }
                            });

                            // Update lazy load
                            if (window.lazyLoadInstance) {
                                window.lazyLoadInstance.update();
                            }
                        },
                        slideChange: function (swiper) {
                            updateCounter(swiper);
                        }
                    }
                });

                // Add click handlers to thumbnails to change main slide (if thumbs exist)
                if (thumbSwiper && navSwiper) {
                    const thumbSlides = sliderFor.querySelectorAll('.swiper-slide');
                    thumbSlides.forEach((slide, index) => {
                        slide.style.cursor = 'pointer';
                        slide.addEventListener('click', () => {
                            navSwiper.slideTo(index);
                            syncThumbActive(thumbSwiper, index);
                        });
                    });

                    // Ensure the active thumb matches the main slide
                    syncThumbActive(thumbSwiper, navSwiper.realIndex);
                    navSwiper.on('slideChange', () => {
                        syncThumbActive(thumbSwiper, navSwiper.realIndex);
                    });
                }
            }
        }

        // Initialize thumbnail slider (For) if exists and not already initialized - VERTICAL THUMBS
        // This handles cases where thumbs weren't initialized in the default layout above
        if (sliderFor && !sliderFor.classList.contains('swiper-initialized')) {
            const isLayoutFull = productView.classList.contains('layout-4');

            if (!isLayoutFull && navSwiper && (!navSwiper.thumbs || !navSwiper.thumbs.swiper)) {
                // Get navigation buttons from thumbnail wrapper (already in HTML)
                const thumbnailWrapper = sliderFor.parentElement;
                const thumbNextBtn = thumbnailWrapper?.querySelector('.swiper-button-next');
                const thumbPrevBtn = thumbnailWrapper?.querySelector('.swiper-button-prev');

                // Initialize thumbnail slider as vertical
                const thumbSwiper = new Swiper(sliderFor, {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    loop: false,
                    watchOverflow: true,
                    freeMode: true,
                    watchSlidesProgress: true,
                    navigation: thumbNextBtn && thumbPrevBtn ? {
                        nextEl: thumbNextBtn,
                        prevEl: thumbPrevBtn
                    } : false,
                    on: {
                        init: function (swiper) {
                            if (window.lazyLoadInstance) {
                                window.lazyLoadInstance.update();
                            }
                        }
                    }
                });

                // Connect main slider with thumbs
                if (navSwiper && thumbSwiper) {
                    // Set thumbs on main slider
                    navSwiper.thumbs.swiper = thumbSwiper;
                    navSwiper.thumbs.init();
                    navSwiper.thumbs.update();

                    // Add click handlers to thumbnails to change main slide
                    const thumbSlides = sliderFor.querySelectorAll('.swiper-slide');
                    thumbSlides.forEach((slide, index) => {
                        slide.style.cursor = 'pointer';
                        slide.addEventListener('click', () => {
                            navSwiper.slideTo(index);
                            syncThumbActive(thumbSwiper, index);
                        });
                    });

                    // Keep thumb active state in sync with main slider
                    syncThumbActive(thumbSwiper, navSwiper.realIndex);
                    navSwiper.on('slideChange', () => {
                        syncThumbActive(thumbSwiper, navSwiper.realIndex);
                    });
                }
            }
        }

        // Remove opacity from nav when initialized
        if (navSwiper && sliderNav) {
            // Opacity handling removed to prevent glitch on cached images
        }

        // Update Swiper navigation if buttons exist in HTML (even if Swiper is already initialized)
        if (sliderFor && sliderFor.classList.contains('swiper-initialized')) {
            const thumbnailWrapper = sliderFor.parentElement;
            if (thumbnailWrapper && thumbnailWrapper.classList.contains('productView-thumbnail-wrapper')) {
                const thumbNextBtn = thumbnailWrapper.querySelector('.swiper-button-next');
                const thumbPrevBtn = thumbnailWrapper.querySelector('.swiper-button-prev');

                // Update Swiper navigation if buttons exist and instance is available
                if (thumbNextBtn && thumbPrevBtn) {
                    // Try multiple ways to access Swiper instance
                    let swiperInstance = sliderFor.swiper ||
                        (window.Swiper && window.Swiper.getInstance && window.Swiper.getInstance(sliderFor)) ||
                        (sliderFor.swiperInstance);

                    if (swiperInstance) {
                        // Update navigation
                        if (swiperInstance.params && swiperInstance.params.navigation) {
                            swiperInstance.params.navigation.nextEl = thumbNextBtn;
                            swiperInstance.params.navigation.prevEl = thumbPrevBtn;
                            if (swiperInstance.navigation) {
                                swiperInstance.navigation.init();
                                swiperInstance.navigation.update();
                            }
                        } else if (swiperInstance.params) {
                            swiperInstance.params.navigation = {
                                nextEl: thumbNextBtn,
                                prevEl: thumbPrevBtn
                            };
                            if (swiperInstance.navigation) {
                                swiperInstance.navigation.init();
                                swiperInstance.navigation.update();
                            }
                        }
                    }
                }
            }
        }

        // Initialize mobile slider if exists
        if (sliderForMobile && !sliderForMobile.classList.contains('swiper-initialized')) {
            let mobileWrapper = sliderForMobile.querySelector('.swiper-wrapper');
            if (!mobileWrapper) {
                mobileWrapper = document.createElement('div');
                mobileWrapper.className = 'swiper-wrapper';
                Array.from(sliderForMobile.children).forEach(slide => {
                    slide.classList.add('swiper-slide');
                    mobileWrapper.appendChild(slide);
                });
                if (mobileWrapper.children.length > 0) sliderForMobile.appendChild(mobileWrapper);
                else return;
            }

            new Swiper(sliderForMobile, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    init: function () {
                        if (window.lazyLoadInstance) {
                            window.lazyLoadInstance.update();
                        }
                    }
                }
            });
        }

        // Return swipers for external access
        return {
            nav: navSwiper,
            for: forSwiper
        };
    }

    // Initialize product gallery with opacity handling
    function initProductImageGalleryWithOpacity(scope) {
        const productView = scope || document.querySelector('.productView');
        if (!productView) return;

        // Initialize gallery
        const result = initProductImageGallery(scope);

        // Remove opacity when initialized
        if (productView) {
            productView.setAttribute('data-gallery-initialized', 'true');
        }

        return result;
    }

    // Initialize product galleries immediately (critical component, above the fold)
    function initProductGalleriesWithObserver() {
        const productViews = document.querySelectorAll('.productView');
        if (!productViews.length) return;

        // Initialize immediately - no opacity delay for product gallery (critical component)
        productViews.forEach(view => {
            initProductImageGallery(view);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProductGalleriesWithObserver);
    } else {
        initProductGalleriesWithObserver();
    }

    // Export for external use
    window.initProductImageGallery = initProductImageGallery;
})();

